import React from 'react'
import DashboardApiTableShow, {DashboardColumn} from './DashboardApiTableShow'
import {RatingChangeItem} from './dashboardTableTypes'
import {
  formatDashboardRating,
  renderDashboardDateTwoLine,
  renderDashboardLinkIcon,
  renderDashboardSku,
} from './dashboardFormatters'

// Rating value with a filled star before it; missing values stay a plain "-".
const renderRating = (value: number | string | null | undefined): React.ReactNode => {
  const formatted = formatDashboardRating(value)
  if (formatted === '-') return formatted
  return (
    <span className='d-inline-flex align-items-center gap-1'>
      <svg width='16' height='16' viewBox='0 0 24 24' fill='#ffc700' aria-hidden='true'>
        <path d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z' />
      </svg>
      {formatted}
    </span>
  )
}

const columns: DashboardColumn<RatingChangeItem>[] = [
  {header: 'SKU', sortKey: 'sku', render: (item) => renderDashboardSku(item.sku)},
  {header: 'Channel', sortKey: 'channel', render: (item) => item.channel ?? '-'},
  {header: 'Type', sortKey: 'type', render: (item) => item.type ?? '-'},
  {header: 'Old Value', sortKey: 'old_value', render: (item) => renderRating(item.old_value)},
  {header: 'New Value', sortKey: 'new_value', render: (item) => renderRating(item.new_value)},
  {header: 'Changed At', sortKey: 'changed_at', width: 160, render: (item) => renderDashboardDateTwoLine(item.changed_at)},
  {header: 'Url', width: 120, render: (item) => renderDashboardLinkIcon(item.broken_link)},
]

function RatingChangesShow() {
  return <DashboardApiTableShow<RatingChangeItem> endpoint='RatingChanges' title='Rating Changes' columns={columns} />
}

export default RatingChangesShow
